import { RouteConfig } from 'vue-router';
import { Routes } from '@/router/Routes';

const BankStmtRoutes: RouteConfig = {
    path: 'bank_stmts_quiz',
    component: () => import('../views/StatementsNavigation.vue'),
    redirect: '/bank_stmts_quiz/start',
    children: [
        {
            path: 'start',
            name: Routes.BANK_STMTS_QUIZ.START_BANK_STMTS_QUIZ,
            component: () => import('../views/BankStatementsQuiz.vue'),
        },
    ],
}

export default BankStmtRoutes;